<template>
  <div>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="outWarehouse(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryReturnOutFun } from 'api/returnCheck';

export default {
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    // ----------------------------获取数据
    queryData() {
      queryReturnOutFun()
        .then((result) => {
          if (result) {
            this.tableData = result;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    outWarehouse(row) {
      this.$router.push({ name: 'returnOutDetail' });
      sessionStorage.setItem('oreder_id', row.ORDER_ID);
      sessionStorage.setItem('SUPPLIER_ID', row.SUPPLIER_ID);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/returnCheck/returnOutStock.vue